import { Layout } from "@mcleod/components";

export class AlignmentDemo extends Layout {
    getDemoPath() {
        return ["Concepts", "Alignment"];
    }
}
